<app-main-nav>
<router-outlet></router-outlet>
</app-main-nav>
<accept-cookies></accept-cookies>
<app-footer></app-footer>

